

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DELETENEWSLETTER= createAsyncThunk(
  "deleteNewsletter/deleteNewsletter",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteNewsletterSlice = createSlice({
  name: "deleteNewsletterSlice",
  initialState: {
    deleteNewsletter: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteNewsletter: (state) => {
        state.deleteNewsletter.loading = false
        state.deleteNewsletter.error = false
        state.deleteNewsletter.data = []
        state.deleteNewsletter.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETENEWSLETTER.fulfilled, (state, action) => {
      state.deleteNewsletter = {
        ...state.deleteNewsletter,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETENEWSLETTER.pending, (state, action) => {
      state.deleteNewsletter = {
        ...state.deleteNewsletter,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETENEWSLETTER.rejected, (state, action) => {
      state.deleteNewsletter = {
        ...state.deleteNewsletter,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteNewsletterAction = {
    DELETENEWSLETTER,
};

export { deleteNewsletterAction };
export default deleteNewsletterSlice.reducer;
export const {setInitialStateOfdeleteNewsletter} = deleteNewsletterSlice.actions
